export default __webpack_public_path__ + "static/B0126-1a5d0afab04e7c15c6d7b0c9b1912323.png";